import React, { useContext } from 'react';
import { Table } from 'react-bootstrap';
import './_table.scss'

import Head from './Head';
import Body from './Body';
import { Context } from '../../index';

const HideServicesTable = () => {
  const [state] = useContext(Context);
  const { services, configuration, isLoadingTable } = state

  return (
    <>
      <Table>
        <Head />
        <Body
          items={services}
          isLoading={isLoadingTable}
          config={configuration}
        />
      </Table>
    </>
  );
}

HideServicesTable.propTypes = {

};

export default HideServicesTable;
